export default __webpack_public_path__ + "static/media/shadow.bf2cbf00.png";